export default __webpack_public_path__ + "static/media/169.82cb9200.jpg";